var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_486",
    "data-name": "Group 486",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 247.591,
    height: 59.855,
    viewBox: "0 0 247.591 59.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 247.591,
    height: 59.855,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M116,6.764a2.458,2.458,0,0,0-3.63,0l-9.429-4.5c-1.588,1-2.065,1.3-3.653,2.3v8.426l3.653,2.3,8.763-4.183v5.651a2.481,2.481,0,1,0,4.962,0V11.113l8.763,4.183,3.653-2.3V4.566c-1.588-1-2.064-1.3-3.653-2.3Z",
    transform: "translate(-99.29 -2.262)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 10.338,
    height: 10.337,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M131.876,40.194a17.462,17.462,0,1,1-17.463-17.463,17.463,17.463,0,0,1,17.463,17.463",
    transform: "translate(9.382 2.198)",
    fill: "#fbb624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M116.548,42.763a3.377,3.377,0,1,1-3.377-3.377,3.377,3.377,0,0,1,3.377,3.377",
    transform: "translate(10.624 3.811)",
    fill: "#ca7f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M111.437,43.375v12.2c.519.046,1.042.079,1.574.079s1.056-.033,1.576-.079v-12.2Z",
    transform: "translate(10.783 4.196)",
    fill: "#ca7f00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 39.119,
    height: 3.308,
    transform: "translate(104.236 37.988)",
    fill: "#fbb624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M113.41,28.2a6.087,6.087,0,1,1,6.087-6.087A6.094,6.094,0,0,1,113.41,28.2m0-9.693a3.606,3.606,0,1,0,3.606,3.606A3.61,3.61,0,0,0,113.41,18.5",
    transform: "translate(10.385 1.55)",
    fill: "#fbb624"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 39.119,
    height: 1.654,
    transform: "translate(104.236 39.643)",
    fill: "#ca7f00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 247.591,
    height: 59.855,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M113.092,18.918a2.481,2.481,0,0,1-2.481-2.481V8.117a2.481,2.481,0,1,1,4.962,0v8.32a2.481,2.481,0,0,1-2.481,2.481",
    transform: "translate(10.703 0.545)",
    fill: "#f7ad4b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(108.898 2.481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(9.728 1.348)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M118.5,8.66a5.169,5.169,0,1,1-5.169-5.169A5.169,5.169,0,0,1,118.5,8.66",
    transform: "translate(-108.16 -3.492)",
    fill: "#f7ad4b"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M117.035,8.542a3.825,3.825,0,1,1-3.826-3.826,3.825,3.825,0,0,1,3.826,3.826",
    transform: "translate(10.585 0.456)",
    fill: "#f7ad4b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3ca0bbb34898522058f612a8bf68f023.svg";
export { ForwardRef as ReactComponent };